import AuthContext from "context/AuthContext";
import { useContext } from "react";
import ParamsAsset from "./waste/ParamsAsset";
import ParamsAssetBridge from "./bridge/ParamsAssetBridge";

const ParamsAssetsManager = ({ item, handleResetZoom, dateRange, setDateRange, lastMeasure }) => {
    const { panel } = useContext(AuthContext);
    switch (panel.panel_type) {
        case 'b':
            return (
                <ParamsAssetBridge item={item} handleResetZoom={handleResetZoom} dateRange={dateRange} setDateRange={setDateRange} lastMeasure={lastMeasure} />
            );
        default:
            return (
                <ParamsAsset item={item} handleResetZoom={handleResetZoom} dateRange={dateRange} setDateRange={setDateRange} />
            );
    };
};
export default ParamsAssetsManager;
